import { render, staticRenderFns } from "./importAndDowloadCmp.vue?vue&type=template&id=37bd0e24"
import script from "./importAndDowloadCmp.vue?vue&type=script&lang=js"
export * from "./importAndDowloadCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bd0e24')) {
      api.createRecord('37bd0e24', component.options)
    } else {
      api.reload('37bd0e24', component.options)
    }
    module.hot.accept("./importAndDowloadCmp.vue?vue&type=template&id=37bd0e24", function () {
      api.rerender('37bd0e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/OtherCmp/importAndDowloadCmp.vue"
export default component.exports